export const AnnoAlertConstant = {
    ANNO_UPDATE_INITIATED : "ANNO_UPDATE_INITIATED",
    ANNO_UPDATE_SUCCESS : "ANNO_UPDATE_SUCCESS",
    ANNO_UPDATE_FAILED : "ANNO_UPDATE_FAILED",
    ANNO_SELECT_ID : "ANNO_SELECT_ID",
    ANNO_DELETE_SUCCESS :"ANNO_DELETE_SUCCESS"
} 


